import React from 'react';
import {
  Button,
  Callout,
  Position,
} from '@blueprintjs/core';
import {Popover2, Tooltip2} from '@blueprintjs/popover2';
import {IconNames} from '@blueprintjs/icons';

import './QueryDetails.scss';
import {EXECUTION_STATUS} from '../constants';
import {formatDate} from '../../../utils/date';
import {getDuration} from './utils';

interface QueryDetailsProps {
  query: any | null;
  status?: string;
}

const Content = ({query}: any) => {
  return (
    <div className="query-details-popover">
      <div>Query started at <strong>{formatDate(query.startDttm)}</strong>, took
        <strong>{getDuration(query)}</strong> seconds.</div>
      <div>Query executed on database <strong>{query.db}</strong>.</div>
      <div>Query returned <strong>{query.rows || '-'}</strong> rows.</div>
      <br/>
      <Callout
        title="Executed SQL">
        <div className="executed-sql">{query.executedSql}</div>
      </Callout>
    </div>
  )
};

const QueryDetails = ({
  query,
  status,
}: QueryDetailsProps) => {
  if (!query || !status) {
    return null;
  } if ([EXECUTION_STATUS.PENDING, EXECUTION_STATUS.RUNNING].includes(status as any)) {
    return null;
  }

  return (
    <Popover2
      content={
        <Content
          query={query}
        />
      }
      position={Position.BOTTOM_RIGHT}
    >
      <Tooltip2
        hoverOpenDelay={1000}
        content="Query Details"
      >
        <Button
          minimal={true}
          icon={IconNames.CODE}
          small={true}
        />
      </Tooltip2>
    </Popover2>
  );
};

export default QueryDetails;
